let newOperation = [
  {
    path: '/newOperation_index',
    name: '手术预约',
    component: () => import('@/pages/newOperation/newOperation_index')
  },
  {
    path: '/newOperation_docDetail',
    name: '医生详情',
    component: () => import('@/pages/newOperation/newOperation_docDetail')
  },
  {
    path: '/newOperation_detail',
    name: '手术详情',
    component: () => import('@/pages/newOperation/newOperation_detail')
  },
  {
    path: '/newOperation_more_data',
    name: '资料补充',
    component: () => import('@/pages/newOperation/newOperation_more_data')
  },
  {
    path: '/newOperation_diagnose_detail',
    name: '病例及方案',
    component: () => import('@/pages/newOperation/newOperation_diagnose_detail')
  },
  {
    path: '/newOperation_order_pay',
    name: '订单支付',
    component: () => import('@/pages/newOperation/newOperation_order_pay')
  },
  {
    path: '/newOperation_order_list',
    name: '订单列表',
    component: () => import('@/pages/newOperation/newOperation_order_list')
  },
  {
    path: '/newOperation_order_detail',
    name: '订单详情',
    component: () => import('@/pages/newOperation/newOperation_order_detail')
  },
  {
    path: '/newOperation_order_confirm',
    name: '订单确认',
    component: () => import('@/pages/newOperation/newOperation_order_confirm')
  },
  {
    path: '/newOperation_docList',
    name: '医生列表',
    component: () => import('@/pages/newOperation/newOperation_docList')
  },
  {
    path: '/newOperation_humin',
    name: '出诊地点',
    // component: () => import('@/pages/newOperation/newOperation_humin')
    component: () => import('@/pages/newOperation/newOperation_humin_new')
  },
  {
    path: '/newOperation_landing',
    name: '昆明馨安医院',
    component: () => import('@/pages/newOperation/newOperation_landing')
  },
  {
    path: '/newOperation_shikang',
    name: '昆明视康眼科',
    component: () => import('@/pages/newOperation/newOperation_shikang')
  },
  {
    path: '/newOperation_specialists',
    name: '大专家列表',
    component: () => import('@/pages/newOperation/newOperation_specialists')
  },
  {
    path: '/newOperation_specialists_new',
    name: '大专家列表',
    component: () => import('@/pages/newOperation/newOperation_specialists_new')
  },
  {
    path: '/newOperation_specialist_detail',
    name: '专家详情',
    component: () => import('@/pages/newOperation/newOperation_specialist_detail')
    // component: () => import('@/pages/newOperation/newOperation_specialist_detail_new')
  },
  {
    path: '/newOperation_specialist_detail_new',
    name: '专家详情',
    // component: () => import('@/pages/newOperation/newOperation_specialist_detail')
    component: () => import('@/pages/newOperation/newOperation_specialist_detail_new')
  },
  {
    path: '/newOperation_eyes',
    name: '眼口专区',
    component: () => import('@/pages/newOperation/newOperation_eyes')
    // component: () => import('@/pages/newOperation/newOperation_eyes_new')
  },
  {
    path: '/newOperation_eyes_new',
    name: '眼口专区',
    // component: () => import('@/pages/newOperation/newOperation_eyes')
    component: () => import('@/pages/newOperation/newOperation_eyes_new')
  },
  {
    path: '/newOperation_xingqi_new',
    name: '昆明星启眼科医院',
    component: () => import('@/pages/newOperation/newOperation_xingqi_new')
  },
  {
    path: '/newOperation_xingqi_orderConfirm',
    name: '订单确认',
    component: () => import('@/pages/newOperation/newOperation_xingqi_orderConfirm')
  },
  {
    path: '/newOperation_taodan',
    name: '陶丹团队',
    component: () => import('@/pages/newOperation/newOperation_taodan_new')
  },
  {
    path: '/newOperation_sfy_eyes',
    name: '市妇幼儿童眼科',
    component: () => import('@/pages/newOperation/newOperation_sfy_eyes')
    // component: () => import('@/pages/newOperation/newOperation_sfy_eyes_new')
    // component: () => import('@/pages/newOperation/newOperation_sfy_eyes')
  },
  {
    path: '/newOperation_xingqi_branch',
    name: '胡敏博士专家团队',
    component: () => import('@/pages/newOperation/newOperation_xingqi_branch')
  },
  {
    path: '/newOperation_expert_zone',
    name: '大专家专区',
    component: () => import('@/pages/newOperation/newOperation_expert_zone')
  }
]

export default newOperation
